import React, { Component } from 'react'
import { Input, Button } from 'loyal-react'
import PropTypes from 'prop-types'

const numberPattern = /^[0-9]*$/

class AddressForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      zipCode: props.zipCode.value,
      receiver: props.receiver.value,
      number: props.number.value,
      complement: props.complement.value,
      reference: props.reference.value,
      addressConfirmed: false,
      street: {
        value: props.street && props.street.value,
        disabled: props.street.disabled
      },
      district: {
        value: props.district && props.district.value,
        disabled: props.district.disabled
      }
    }
  }

  componentDidUpdate () {
    this.changeAddress()
  }

  changeAddress = () => {
    if (!this.props.isLoading) {
      if (
        this.props.street.value !== this.state.street.value &&
        this.state.street.value === ''
      ) {
        this.setState({
          street: { value: this.props.street.value }
        })
      }

      if (
        this.props.district.value !== this.state.district.value &&
        this.state.district.value === ''
      ) {
        this.setState({
          district: { value: this.props.district.value }
        })
      }
    }
  }

  handleZipCodeChange = ({ target: { value: zipCode } }) => {
    const zipCodeNumber = zipCode.replace('-', '')
    this.setState({ zipCode: zipCodeNumber })
    if (zipCodeNumber.length === 8 && numberPattern.test(zipCodeNumber)) {
      this.setState({
        district: { value: '' },
        street: { value: '' }
      })
      this.props.fetchShipping(zipCodeNumber)
    }
  }

  isZipCodeValid = value => !!value && value.length === 8
  isDistrictValid = value => !!value && value.length > 2
  isStreetValid = value => !!value && value.length > 2

  isFormInvalid = () => {
    const zipCodeNumber = this.state.zipCode.replace('_', '')

    if (this.isZipCodeValid(zipCodeNumber) === false) return true
    if (this.isDistrictValid(this.state.district.value) === false) return true
    if (this.isStreetValid(this.state.street.value) === false) return true

    if (!this.state.number) return true
    if (!this.state.complement) return true
    if (!this.state.reference) return true
    if (!this.props.city.value) return true
    if (!this.state.receiver) return true

    return false
  }

  render () {
    let streetDisabled = true
    let districtDisabled = true

    if (!this.props.isLoading && this.props.city.value !== '') {
      if (this.props.street.value === '') streetDisabled = false
      if (this.props.district.value === '') districtDisabled = false
    }

    if (
      this.state.addressConfirmed &&
      this.props.updateShippingAddress === 'success'
    ) {
      this.props.handleStepChange(2)
    }

    return (
      <div className='address-form col-12 pt-2 px-0'>
        <div className='row'>
          <Input
            id='address-zipCode'
            label='CEP'
            className='col-12 col-md-6'
            value={this.state.zipCode}
            onChange={this.handleZipCodeChange}
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
            required
            disabled={this.props.zipCode.disabled === 'true'}
            data-error='Cep inválido'
            valid={this.props.cepError && this.state.zipCode ? false : null}
          />
          <Input
            id='address-receiver'
            label='Destinatário'
            className='col-12 col-md-6'
            value={this.state.receiver}
            onChange={e => this.setState({ receiver: e.target.value })}
            required
            disabled={this.props.receiver.disabled === 'true'}
          />
          <Input
            id='address-street'
            label='Rua'
            className='col-12 col-md-6 mt-2'
            value={this.state.street.value}
            onChange={e =>
              this.setState({
                street: { value: e.target.value, isValid: null },
                dirty: true
              })
            }
            maxLength='100'
            required
            disabled={streetDisabled}
            data-error='Digite uma Rua'
            valid={this.isStreetValid(this.state.street.value)}
          />
          <Input
            id='address-number'
            label='Número'
            className='col-12 col-md-6 mt-2'
            value={this.state.number}
            onChange={e => this.setState({ number: e.target.value })}
            required
            disabled={this.props.number.disabled === 'true'}
          />
          <Input
            id='address-complement'
            label='Complemento'
            className='col-12 col-md-6 mt-2'
            value={this.state.complement}
            required
            onChange={e => this.setState({ complement: e.target.value })}
            disabled={this.props.complement.disabled === 'true'}
          />
          <Input
            id='address-reference'
            label='Ponto de Referência'
            className='col-12 col-md-6 mt-2'
            value={this.state.reference}
            required
            onChange={e => this.setState({ reference: e.target.value })}
          />
          <Input
            id='address-district'
            label='Bairro'
            className='col-12 col-md-6 mt-2'
            value={this.state.district.value}
            onChange={e =>
              this.setState({
                district: { value: e.target.value, isValid: null },
                dirty: true
              })
            }
            maxLength='100'
            required
            disabled={districtDisabled}
            data-error='Digite um Bairro'
            valid={this.isDistrictValid(this.state.district.value)}
          />
          <Input
            id='address-city'
            label='Cidade'
            className='col-12 col-md-6 mt-2'
            value={this.props.city.value}
            required
            disabled='true'
          />
          <Input
            id='address-state'
            label='Estado'
            className='col-12 col-md-6 mt-2'
            value={this.props.state.value}
            required
            disabled='true'
          />
          <div className='col-12 col-md-6 mt-2 d-none d-md-block'>
            <Button
              className='btn btn-sm btn-featured'
              onClick={() => {
                this.setState({ addressConfirmed: true })
                this.props.handleConfirmAddress({
                  zipCode: this.state.zipCode,
                  receiver: this.state.receiver,
                  number: this.state.number,
                  complement: this.state.complement,
                  reference: this.state.reference,
                  street: this.state.street.value,
                  district: this.state.district.value,
                  city: this.props.city.value,
                  state: this.props.state.value
                })
              }}
              loading={
                this.props.isLoading ||
                this.props.updateShippingAddress === 'loading'
              }
              text='Próximo'
              disabled={this.isFormInvalid()}
            />
          </div>

          <div className='float-button bg-white px-2 py-2 row mx-0 d-block d-md-none'>
            <div className='col-12 px-0'>
              <Button
                className='btn btn-sm btn-featured'
                onClick={() => {
                  this.setState({ addressConfirmed: true })
                  this.props.handleConfirmAddress({
                    zipCode: this.state.zipCode,
                    receiver: this.state.receiver,
                    number: this.state.number,
                    complement: this.state.complement,
                    reference: this.state.reference,
                    street: this.state.street.value,
                    district: this.state.district.value,
                    city: this.props.city.value,
                    state: this.props.state.value
                  })
                }}
                loading={
                  this.props.isLoading ||
                  this.props.updateShippingAddress === 'loading'
                }
                text='Próximo'
                disabled={this.isFormInvalid()}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const valueType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired
}).isRequired

AddressForm.propTypes = {
  receiver: valueType,
  street: valueType,
  number: valueType,
  complement: valueType,
  district: valueType,
  city: valueType,
  state: valueType,
  zipCode: valueType,
  reference: valueType,
  isLoading: PropTypes.bool.isRequired,
  handleConfirmAddress: PropTypes.func.isRequired,
  fetchShipping: PropTypes.func.isRequired,
  updateShippingAddress: PropTypes.string,
  handleStepChange: PropTypes.func,
  cepError: PropTypes.bool
}

export default AddressForm



// WEBPACK FOOTER //
// ./src/features/Checkout/ShippingAddress/Body/AddressForm/AddressForm.js